import * as Common from "../../commons/common"

export class Sheet {
  sheet_group_key: number
  nendo: number
  exec_date: string
  grade: number
  kind: number
  name: string
  rooms: Room[]
  at_full_count: number

  constructor(sheet: any){
    this.sheet_group_key = sheet.sheet_group_key;
    this.nendo = sheet.nendo;
    this.exec_date = sheet.exec_date;
    this.grade = sheet.grade;
    this.kind = sheet.kind;
    this.name = sheet.name;
    this.rooms = sheet.rooms;
    this.at_full_count = sheet.at_full_count;
  }
}

export class Room {
  id: number
  name: string

  constructor(sheet: any){
    this.id = sheet.id;
    this.name = sheet.name;
  }
}

export class ResultListCondition{
  sheet_group_key: string = ""
  nendo: string = ""
  month: string = ""
  grade: string = ""
  kind: string = ""
  page: number = 1
  row_count: number =  Common.SheetListRowCount
}